<template>
  <card>
    <div class="card-header pt-0">
      <h4 class="title mt-0">
        Participant Recommendations
      </h4>
    </div>
    <el-table
      class="table"
      style="width: 100%"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      :data="participants"
    >
      <el-table-column
        label="Participant"
        prop="FullName"
        class-name="text-left"
      />
      <el-table-column
        label="Patrol"
        prop="Critter"
        width="80"
        class-name="text-center"
      />
      <el-table-column
        label="For Sure"
        width="80"
        class-name="align-middle pt-2"
      >
        <template slot-scope="props">
          <p-radio
            class="ml-auto mr-auto"
            label="Forsure"
            v-model="props.row.StaffRecommendation"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Likely"
        width="80"
        class-name="align-middle pt-2"
      >
        <template slot-scope="props">
          <p-radio
            class="ml-auto mr-auto"
            label="Likely"
            v-model="props.row.StaffRecommendation"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Maybe"
        width="80"
        class-name="align-middle pt-2"
      >
        <template slot-scope="props">
          <p-radio
            class="ml-auto mr-auto"
            label="Maybe"
            v-model="props.row.StaffRecommendation"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="Not Likely"
        width="80"
        class-name="align-middle pt-2"
      >
        <template slot-scope="props">
          <p-radio
            class="ml-auto mr-auto"
            label="NotLikely"
            v-model="props.row.StaffRecommendation"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="NYLT"
        width="80"
        class-name="align-middle pt-1"
      >
        <template slot-scope="props">
          <p-checkbox
            class="ml-auto mr-auto"
            v-model="props.row.NyltRecommendation"
          />
        </template>
      </el-table-column>
      <el-table-column label="Comments">
        <template slot-scope="props">
          <fg-input
            name="comments"
            class="align-middle"
            max-length="1500"
            v-model="props.row.RecommendationComments"
            :title="props.row.RecommendationComments"
          />
        </template>
      </el-table-column>
      <el-table-column label="Submit">
        <template slot-scope="props">
          <button
            type="submit"
            class="btn btn-primary mb-1"
            @click="updateRow(props.row.Id)"
          >
            Update
          </button>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>

<script>
import recommendationApi from '@/services/api/recommendation.js'
import PRadio from '@/plugins/paper-components/inputs/p-radio.vue'
import PCheckbox from '@/plugins/paper-components/inputs/p-checkbox.vue'

export default {
  name: 'ReportCloseoutRecommendationsParticipantEdit',
  components: {
    PRadio,
    PCheckbox
  },
  data: function () {
    return {
      participants: [],
      cellStyle: {
        padding: '0',
        'font-size': '10px',
        'text-align': 'center',
        'vertical-align': 'baseline'
      },
      headerCellStyle: {
        padding: '0 0 0 0 !important',
        margin: '0',
        height: '20px',
        'font-size': '10px',
        'vertical-align': 'baseline',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      }
    }
  },
  mounted: function () {
    recommendationApi
      .getParticipant(this.$root.courseKey)
      .then(x => {
        this.participants = x
        this.$emit('participants-counted', x.length)
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    getParticipant: function (id) {
      let returnValue = null
      for (let i = 0; i < this.participants.length; i++) {
        if (this.participants[i].Id === id) {
          returnValue = this.participants[i]
          break
        }
      }
      return returnValue
    },
    updateRow: function (id) {
      const row = this.getParticipant(id)

      if (row !== null) {
        recommendationApi
          .updateParticipant(this.$root.courseKey, row)
          .then(x => {
            this.participants = x
            this.$notify({
              message: 'Update complete.',
              icon: 'nc-icon nc-satisfied',
              type: 'success',
              horizontalAlign: 'center',
              timeout: 2000
            })
          })
          .catch(error => {
            console.log(error)
            this.$notify({
              message: 'There was an error updating your recommendation.',
              icon: 'bi bi-exclamation-circle-fill',
              type: 'error',
              horizontalAlign: 'center',
              timeout: 2000
            })
            this.errormessage = error
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-check-radio {
  margin: 0;
  width: 32px;
}

.form-group {
  margin-bottom: 0px;
}
</style>
